export default "__VITE_ASSET__tcqOu7sC__"